import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {Loader} from "../../../components/admin/Loader";
import {AlbumForm} from "../../../components/admin/album/AlbumForm";
import {PhotoManager} from "../../../components/admin/album/PhotoManager";
import {albumResultType} from "../../../types/Api/AlbumResultType";
import {album} from "../../../models/album";
import {albumHydrator} from "../../../models/hydrator/albumHydrator";
import {BoxTitle} from "../../../components/admin/BoxTitle";

export const Edit = () => {
  const uuid: undefined|string = useParams().uuid;

  const [album, setAlbum] = useState(undefined as undefined | album);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setAlbum(undefined);

    if (uuid) {
      const result = ApiService.get(`/album/${uuid}`) as Promise<albumResultType>;

      setLoading(true);

      result
        .then((r) => {
          setAlbum(albumHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && (album || !uuid) && (
        <>
          <BoxTitle title={album ? `Album « ${album.label} »` : 'Ajouter un album'}/>
          <AlbumForm key={album?.albumId ?? 'new'} album={album}/>
          {album && (
            <>
              <hr/>
              <PhotoManager album={album} change={setAlbum}/>
            </>
          )}
        </>
      )}
    </>
  );
}
